import { FormInstance, useForm } from 'antd/lib/form/Form'
import { Store } from 'antd/lib/form/interface'
import { PropsWithChildren, createContext } from 'react'
import { NotificationEventItem } from '@cims-online/shared'
import { useGenericStrictContext } from 'utils/createContext'

const Context = createContext(null)

type CIMSNotificationsPanelContext<T extends NotificationEventItem> =
  WithEvent<T>

export function useCIMSNotificationsPanelContext<
  Event extends NotificationEventItem
>() {
  return useGenericStrictContext<CIMSNotificationsPanelContext<Event>>(
    Context,
    'CIMSNotificationsPanelContext'
  )
}
function CIMSNotificationsPanelProvider<
  Event extends NotificationEventItem,
  U extends Store
>({
  children,
  event,
}: PropsWithChildren<Pick<CIMSNotificationsPanelContext<Event>, 'event'>>) {
  const [form] = useForm<U>()
  const value: CIMSNotificationsPanelContext<Event> = { event, form }
  // we're doing this on purpose because we can't use createStictContext with generics
  return (
    <Context.Provider value={value as unknown as null}>
      {children}
    </Context.Provider>
  )
}

export default CIMSNotificationsPanelProvider

export interface WithEvent<
  T extends NotificationEventItem = NotificationEventItem
> {
  /**
   * a singular {@link NotificationEventItem}
   */
  event: T

  form: FormInstance
}
